export default __webpack_public_path__ + "c0b8d5f6dc861fa398b5b2e7ba965a58.svg";